export function DocumentEditor({ render }) {
  return render();
}
